import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

export interface ConfirmationDialogData {
  message: string;
  confirmBtnText: string;
  cancelBtnText: string;
}

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})
export class ConfirmationDialogComponent implements OnInit {
  constructor(
      public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public dialogData: ConfirmationDialogData
  ) {}

  onClose(): void { this.dialogRef.close(undefined); }

  onDismiss(): void { this.dialogRef.close(false); }

  submit(): void { this.dialogRef.close(true); }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {}
}
